import React from 'react';
import PropTypes from 'prop-types';
import PrivateRoute from '../private-route';
import {Route, matchPath} from 'react-router-dom';
import NotFound from '../../views/route-not-found';
import ActiveApplicationContext from '../../contexts/active-application-context';
import defaultRoutes from './default-routes';

export default function Router(props) {
  const {applications} = props;
  const {setActiveApplication} = React.useContext(ActiveApplicationContext);

  return (
    <Route
      render={renderProps => {
        for (const application of [...applications, defaultRoutes]) {
          const routes = application.routes;

          for (const route of routes) {
            if (matchPath(renderProps.location.pathname, route)) {
              const {
                secure,
                layout: Layout,
                component: Component,
                path,
                exact,
                permission,
                skipApplicationCheck,
              } = route;
              const RouteType = secure ? PrivateRoute : Route;

              setActiveApplication(application);

              return (
                <RouteType
                  path={path}
                  exact={exact}
                  permission={permission}
                  applicationId={skipApplicationCheck ? undefined : application.id}
                  render={innerProps => (
                    <Layout {...innerProps}>
                      <React.Suspense fallback={<div />}>
                        <Component {...innerProps} />
                      </React.Suspense>
                    </Layout>
                  )}
                />
              );
            }
          }
        }
        return <Route component={NotFound} />;
      }}
    />
  );
}

Router.propTypes = {
  /** The applications to register routes for. */
  applications: PropTypes.array.isRequired,
};
